import React from "react";
import ProgramTemplate from "@/components/ProgramTemplate";
import { PROGRAM_EM_45 } from "@/lib/programData";

export default function ErgMarrakech45Page() {
  return <ProgramTemplate program={PROGRAM_EM_45} variant="em" showJourneyChronology />;
}
